import React from 'react'

const TechnicianRecovery = () => {
  return (
    <div>TechnicianRecovery</div>
  )
}

export default TechnicianRecovery